/**
 * Pending withdraw counter Replacer
 */

define(function(require, exports, module) {
    'use strict';
    var BaseReplacerView = require('common/base.replacer.view');
    var PendingCollection = require('portlets/cashier/pending/pending.collection');

    module.exports = BaseReplacerView.extend({

        accessRules: {
            allow: ['user']
        },

        tagName: 'span',

        initialize: function() {
            this.pendigcollection = new PendingCollection();
            this.pendigcollection
                .fetch()
                .done(this.success.bind(this))
                .fail(this.fail.bind(this));
        },

        success: function(response) {
            if (response.data.payments) {
                this.$el.html(response.data.payments.transaction.length);
            }
        },

        fail: function(response) {
            this.$el.html(response.data.errorMessage);
        }

    }, {
        nameOfReplacers: [
            'PENDING_WITHDRAWALS_COUNT'
        ]
    });
});
